import GoalSheet from './modules/GoalSheet.jsx';
import Whiteboard from './modules/Whiteboard.jsx';
import CashFlow from './modules/CashFlow.jsx';
import MoneySits from './modules/MoneySits.jsx';
import Investments from './modules/Investments.jsx';
import InvestmentCost from './modules/InvestmentCost.jsx';
import Protection from './modules/Protection.jsx';
import NextSteps from './modules/NextSteps.jsx';
import { isReading } from '../../store/assessmentPages.js';

// One page of the assessment, from its model. The meeting and the takeaway
// both render through here, so the two cannot drift apart: whatever the
// client saw in the room is what they take home, with the ink where it was.

// Everything after the goal sheet and the whiteboard is follow-up reading, and
// says so in the page's top margin, so a client going through the takeaway
// later knows which pages were talked through and which are theirs to read.
function body(step, page, asOf) {
  switch (step) {
    case 'goals':
      return <GoalSheet sheet={page.sheet} lead={page.lead} told={page.told} toldShown={page.toldShown !== false} toldFromMeeting={Boolean(page.toldFromMeeting)} toldLocked={Boolean(page.toldLocked)} name={page.name} asOf={asOf} />;
    case 'whiteboard':
      return <Whiteboard />;
    case 'cash':
      return <CashFlow timeline={page.timeline} callouts={page.callouts} />;
    case 'tax':
      return <MoneySits snapshot={page.snapshot} callouts={page.callouts} triangle={page.triangle !== false} />;
    case 'investments':
      return <Investments analysis={page.analysis} allocation={page.allocation} callouts={page.callouts} />;
    case 'costs':
      return <InvestmentCost fees={page.fees} unpriced={page.unpriced} advisory={page.advisory} allIn={page.allIn} callouts={page.callouts} />;
    case 'protection':
      return <Protection checklist={page.checklist} />;
    case 'next':
      return <NextSteps workingOn={page.workingOn} questions={page.questions} />;
    default:
      return null;
  }
}

export default function PageBody({ step, page, asOf }) {
  if (!page) return null;
  return (
    <>
      {isReading(step) ? <div className="conv-reading-tag">Follow-up reading</div> : null}
      {body(step, page, asOf)}
    </>
  );
}
